<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-spacer />
              <v-col
                cols="10"
                class="pb-0"
              >
                <v-img
                  :src="img"
                  height="100%"
                  width="100%"
                />
              </v-col>
              <v-spacer />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  components: {},
  data: () => ({
    // Form
    dialog: false,
    img: null,
    title: null,
  }),
  watch: {},
  methods: {
    openDialog(img, title) {
      this.img = `data:image/jpeg;base64, ${img}`;
      this.title = title;
      this.dialog = true;
    },
  },
};
</script>

  <style scoped>
  .mrp-btn-add {
    min-width: 35px !important;
    padding: 0 !important;
  }
  </style>
